module.exports = __webpack_public_path__ + "img/Constellation-01.da7884de.png";